'use strict';

/**
 *
 * @name: nnContributorList
 *
 */

import _get from 'lodash.get'

import DirectiveTemplate from './nn-contributor-list.directive.html';
import './nn-contributor-list.directive.scss';

function NnContributorListDirective ($rootScope, memberAnalytics) {

  'ngInject'

  return {
    replace: true,
    restrict: 'A',
    template: DirectiveTemplate,
    transclude: true,
    scope: {
      content: '&',
      loaded: '='
    },
    controller: DirectiveController
  }

  function DirectiveController ($scope, apiUserService, transObject, $element) {


    'ngInject'; // jshint ignore:line

    /*
    *
    * @CONFIG
    *
    */

    $scope.item = $scope.content();
    $scope.item.title = $scope.item.title || 'Nowness Contributors';
    $scope.settings = {
      contributorLimit: 5,
      page: 1,
      total: null
    };
    $scope.analytics = memberAnalytics;

    /*
    *
    * @PUBLIC
    *
    */

    $scope.loadAll = function() {
      $scope.settings.contributorLimit = 888;

      apiUserService
        .listUsers(1, $scope.settings.total, ['contributor'], false, false, false, false, false, $scope.item.jsonData.sources[0].ProfessionId)
        .then(function(res) {

          res.data.items.forEach(function(item, index) {

            if (index >= 14) {

              transObject.trueSlug(item);
              $scope.contributors.push(item);
            }
          });

          $scope.dontShowMore = true;
        });
    };

    /*
    *
    * @PRIVATE
    *
    */

    function _terminate () {
      $scope.$destroy();
      $element.find('*').remove();
      $element.remove();
    }

    function _fetchData () {
      apiUserService
        .listUsers(1, 15, ['contributor'], _get($scope, 'item.jsonData.sources[0].order'), false, false, false, false, _get($scope, 'item.jsonData.sources[0].ProfessionId'))
        .then(function(res) {

          $scope.settings.total = res.data.meta.totalItems;
          res.data.items.forEach(function(item) {
            transObject.trueSlug(item);
          });
          $scope.contributors = res.data.items;
          $scope.loaded = true;
        })
        .catch(() => {
          _terminate()
        })
    }

    /*
    *
    * @INIT
    *
    */

    _fetchData()

  }
}

export default NnContributorListDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-contributor-list/nn-contributor-list.directive.js